// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___8HzY","colMin":"styles_colMin__SyJ9a"};